import React, { useState } from "react";
import { Row, Col, Button, Form } from "react-bootstrap";
import { propTypes } from "react-bootstrap/esm/Image";
import CustomFormCheck from "utils/CustomFormCheck";

export default function PersonBox({ firstName, lastName, job, email, poc, phone, removePerson, id }) {
  return (
    <>
      <Row>
        <Col>
          <p className="visby-medium f16 light-primary">
            {firstName} {lastName}
          </p>
        </Col>
        <Col className="d-flex pr-0 justify-content-end">
          <i onClick={() => removePerson(id, email)} className="fas fa-minus-circle"></i>
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="nunito-regular f14 light-primary">{email} </p>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col>
          <p className="nunito-regular f14 light-primary">{phone} </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="light-label">
            <CustomFormCheck id={email} checked={poc} label="Primary point of contact" />
            <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
          </div>
        </Col>
      </Row>
    </>
  );
}
